import { TextFieldDefinitionLogicBase } from './text-logic-base';

export class ShortTextFieldDefLogic extends TextFieldDefinitionLogicBase {
    // Constructor.
    public constructor() {
        super();
    };

    public getDefaultMaxLengthWhenInGrid(): number {
        return 250;
    }

    public includeInFormTemplateInstancesGrid(): boolean {
        return true;
    }

    public get canParticipateInFlexFieldBehavior(): boolean {
        return true;
    }

    public get canParticipateInConcatenatorFieldBehavior(): boolean {
        return true;
    }

    public get isNonFlexFieldButCanParticipateInFlexFieldBehavior(): boolean {
        return true;
    }
}
